import { RouteObject } from 'react-router-dom'
import { Loading } from '@vnetwork/datacentral-ui/feedback'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { lazy, Suspense } from 'react'

const TechnicalDashboard = lazy(() => import('./Dashboard'))

const LoadingFallback = () => <Loading />

const TechnicalModule: RouteObject = {
    path: 'technical',
    children: [
        {
            path: '',
            element: (
                <Suspense fallback={<LoadingFallback />}>
                    <TechnicalDashboard />
                </Suspense>
            ),
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default TechnicalModule
